const FeatureOneList = [
    'Amazing feature for enhanced Porformance',
    'Meta Description Optimization',
    'High Performing Solutions To Transform',
];

const FeatureTwoIcon = [
    { icon: 'star-fill' },
    { icon: 'star-fill' },
    { icon: 'star-fill' },
    { icon: 'star-fill' },
    { icon: 'star-fill' },
];

const FeatureThereeList = [
    'Impact - looks at the social benefit (SASB, IRIS, GRI)',
    'ESG - looks at Environmental, Social & Governance practices',
    'UN SDG - UN Sustainable Development Goals such as Gender Equality & Decent Work & Economic Growth',
];

const Frameworks1 = [
    'Human Capital Metrics',
    'Labour Practices',
    'Employees Health & Safety',
    'Employee Engagement',
    'Diversity in Supply Chain Management',
];

const Frameworks2 = [
    'Gender & Cultural Diversity at Board, Employee, Manager and Executive levels.(%)',
    'Employees with Disabilities & Neurodiversity(%)',
    'Gender & cultural/ethnic diversity in new recruits(%)',
    'Promotion , Career Development, Skills Training offered at varying seniority levels (Process/No Process)',
    'Day Care, Flexible Working Hours provided or required (Process/No Process)',
];

const Frameworks3 = [
    'Diversity of Governance Bodies & Employees (demographic - %)',
    'Ratio of basic salary & remuneration (women to men - %)',
    'Anti-Discriminatory Policy (Process/No Process)',
    'Bias-Reducing Investment Practices (Process/No Process)',
    'Companies considered for Investment (by ethnicity and/Race - %)',
];

const FeatureThereeList4 = [
    'Be clear on why you have a diversity strategy in the first place',
    'Define what you want to learn and fix about your workforce, portfolio and/or others',
    'Let the requirements of your analysis drive your choice of data to collect',
];

const FeatureThereeList5 = [
    'Give your data subjects the option of not sharing their sensitive information',
    'Ensure that the sensitive data collected is non-personally identifiable',
    'Align your process with GDPR, Disability & Data Protection Acts amongst others.',
    'Use 3rd Party Diversity Data Solution Partners if not confident',
];

const FeatureThereeList6 = [
    'Look beyond demographics for better insights.',
    'Explore inclusion metrics such as sense of belonging and trust',
    'Perform inter-sectional analysis',
    'Do not force biases in your analysis, let the data speak for itself',
    'Set goals and measure your KPIs',
];

const Strategy1 = [
    'Take data-driven approach to look at workforce composition & set goals',
    'Increase representation in the workforce & at management & board level',
    'Design recruitment and selection processes that encourages participation of diverse candidates',
    'Leverage technology to find & attract diverse talents',
];

const Strategy2 = [
    'Measure sense of belonging, trust, psychological safety amongst others',
    'Set Inclusive policies such as flexible hours',
    'Foster inclusion with benefits such as Day Care Services',
    'Measure Employee Satisfaction',
];

const Strategy3 = [
    'Equal Pay',
    'Fair promotion policy',
    'Anti-discrimination Policy',
    'Employee retention strategies',
    'Equal access to resources & growth opportunities',
];

const Strategy4 = [
    'Up-skill & train minority groups',
    'Integrate well-being into the workforce',
    'Career development process',
    'Mentorship & sponsorship for minority groups',
];

export {
    FeatureOneList,
    FeatureTwoIcon,
    FeatureThereeList,
    FeatureThereeList4,
    FeatureThereeList5,
    FeatureThereeList6,
    Strategy1,
    Strategy2,
    Strategy3,
    Strategy4,
    Frameworks1,
    Frameworks2,
    Frameworks3,
};
